"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgTick(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "5 -4 14 24" }, props),
        React.createElement("path", { d: "M6.603 7.317L5 8.959 9.627 14 19 3.642 17.397 2l-7.77 8.586z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Tick')(SvgTick);
//# sourceMappingURL=Tick.js.map